import React from "react";
import { MagnifyingGlass, X } from "phosphor-react";
import { InputWithHelpersFloatingLabel } from "./Shared";

export function MMCodeInput({ value, setValue, setShowMMCodeModal, validate }) {
  return (
    <InputWithHelpersFloatingLabel
      type="text"
      label="MM Code*"
      id="mm-code"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      helpers={[<MagnifyingGlass weight="thin" size={14} onClick={() => setShowMMCodeModal(true)} />, <X weight="thin" size={14} onClick={() => setValue("")} />]}
      // onFocus={() => setShowMMCodeModal(true)}
      validate={validate}
    />
  );
}
